export default __webpack_public_path__ + "static/media/naturpool-1.ba3eff7f.jpeg";